import React from "react";
import { Translate } from "components/common/Translate/Translate";
import { ImageConverterPageTemplateInterface } from "@/templates/ImageConverterPageTemplateInterface";
import { DynamicImageView } from "components/common/DynamicImageView/DynamicImageView";

export const ImageConverterSection6 = ({ template }: { template: ImageConverterPageTemplateInterface }) => {
    const section6 = template.section6;
    if(!section6) return <></>;
    return (
        <div className={" flex flex-c ol md:flex-row items-center mt-24 md:mt-[150px]"}>
            <div className="flex-1 dark:text-white text-center md:text-left">
                <h2 className="text-24 font-semibold ">
                    <Translate keyName={section6.title} />
                </h2>
                <p className="pt-1">
                    <Translate keyName={section6.subTitle} />
                </p>
                {/*Image for mobile view*/}
                <div className="flex-1 gap-2  md:hidden">
                    <DynamicImageView
                        image={section6.graphics}
                        alt={"Convert Images to Multiple Formats Sample Image"}
                        className="pt-16"
                    />
                </div>
            </div>
            {/*Image for DesktopView*/}
            <div className="flex-1 gap-2 hidden md:block">
                <DynamicImageView image={section6.graphics}
                className="pl-16"
                />
            </div>
        </div>
    );
};
